import React from "react";

const Threads = ({ data }) => {
  return (
    <div className="threads-container">
      {!data.length ? (
        <div className="no-thread">
          <p>No Thread at this Moment</p>
        </div>
      ) : (
        <>
          <div className="thread-card glass-effect">
            <div className="user-details">
              <img
                src={data[0].image}
                alt="Profile"
                className="user-profile-image"
              />
              <p>{data[0].userName}</p>
              <p className="created-at">{data[0].createdAt}</p>
              <img
                src={"/icons/like.svg"}
                alt="Like"
                className="cursor-pointer"
              />
              <p className="reply cursor-pointer">Reply</p>
            </div>
            <div className="content">
              <img src="/image-3.png" alt="" />
              <div>
                <h3>{data[0].title}</h3>
                <p>{data[0].desc}</p>
              </div>
            </div>
          </div>
          {data.slice(1)?.map((data, index) => (
            <div className="thread-card glass-effect" key={index}>
              <div className="user-details">
                <img
                  src={data.image}
                  alt="Profile"
                  className="user-profile-image"
                />
                <p>{data.userName}</p>
                <p className="created-at">{data.createdAt}</p>
                <img
                  src={"/icons/like.svg"}
                  alt="Like"
                  className="cursor-pointer"
                />
                <p className="reply cursor-pointer">Reply</p>
              </div>
              <div className="desc">
                <p>{data.desc}</p>
              </div>
            </div>
          ))}
        </>
      )}
    </div>
  );
};

export default Threads;
